import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";

export default function CTA() {
  return (
    <section className="border-t border-slate-200/80 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-[#1e1b4b] px-8 py-16 text-center sm:px-16 sm:py-20">
          {/* beacon glow */}
          <div className="pointer-events-none absolute -top-32 left-1/2 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[#d4af37]/20 blur-[120px]" />
          <div
            className="pointer-events-none absolute inset-0 opacity-[0.08]"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px)",
              backgroundSize: "44px 44px",
              maskImage: "radial-gradient(ellipse 60% 60% at 50% 0%, black 30%, transparent 75%)",
              WebkitMaskImage: "radial-gradient(ellipse 60% 60% at 50% 0%, black 30%, transparent 75%)",
            }}
          />

          <div className="relative">
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#d4af37]">
              Bottom Line
            </p>
            <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-white sm:text-5xl">
              Reduce Client Acquisition Costs.
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-[15px] text-white/70">
              Fewer wasted impressions. Higher match rates. Sharper lists. The
              math is simple — pay less to reach the people most likely to buy.
            </p>

            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/demo"
                className="group inline-flex items-center gap-2 rounded-xl bg-[#d4af37] px-6 py-3.5 text-sm font-semibold text-[#1e1b4b] transition-all hover:bg-[#e9c659] hover:shadow-[0_18px_40px_-12px_rgba(212,175,55,0.6)]"
              >
                Get a Demo
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex items-center gap-2 rounded-xl border border-white/20 bg-white/5 px-6 py-3.5 text-sm font-medium text-white backdrop-blur transition-all hover:bg-white/10"
              >
                <Calendar className="h-4 w-4" />
                See Pricing
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
